export default __webpack_public_path__ + "static/media/423.79db835a.png";